var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-container center"},[_c('img',{staticStyle:{"position":"absolute","top":"50%","transform":"translateY(-50%)"},attrs:{"src":_vm.logo,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }